import { VariationsConfig } from "../../experiments/ConvertExperimentConfig";

interface AbTestContainerProps {
  variationId: string | null;
  variations: VariationsConfig;
  isLoading?: boolean;
  showControlWhileLoading?: boolean;
}

export function AbTestContainer({
  variationId,
  variations,
  isLoading,
  showControlWhileLoading = true,
}: AbTestContainerProps): JSX.Element | null {
  if (isLoading) {
    // Return control or null based on showControlWhileLoading prop
    return showControlWhileLoading ? variations.control.component || null : null;
  }

  if (variationId) {
    const variationValues = Object.values(variations);
    const foundVariation = variationValues.find(v => v.id === variationId);

    if (foundVariation) {
      return foundVariation.component;
    }
  }

  return variations.control.component || null;
}
